<button class="btn btn-main rounded-5 text-start px-3 w-100" (click)="onDonateClick()">
    <fa-icon [icon]="support" class="me-2"></fa-icon>
    Support
</button>